<template>
  <div>

    <charges-view

        @reloadCharges="fetchSocialSecurityContributions2($event)"
    />

  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import ChargesView from '../../../components/views/ChargesView.vue'
import useAPI from '../../../utils/useAPI'

export default {
  components: {
    ChargesView
  },
  props: {},
  setup () {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const {
      fetchSocialSecurityContributions2,
      fetchAutocompletePaymentMethods,
      fetchAutocompleteBankAccounts,
        fetchAutocompleteContacts
    } = useAPI()

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    fetchSocialSecurityContributions2()
    fetchAutocompletePaymentMethods()
    fetchAutocompleteBankAccounts()
    fetchAutocompleteContacts()

    return {
      // Components

      // Data

      // Computed

      // Methods
      fetchSocialSecurityContributions2,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>